import { AppIdOnlyComponent } from '../rankings/data-widgets/app-id-only.component';
import { AppNameOnlyComponent } from '../rankings/data-widgets/app-name-only.component';
import { DataOnlyComponent } from '../rankings/data-widgets/data-only.component';
import { GridHeaderWithTooltipComponent } from '../rankings/data-widgets/grid-header-with-tooltip.component';
import { OsNameComponent } from '../rankings/data-widgets/os-name.component';
import { RatingSignalComponent } from '../rankings/data-widgets/rating-signal.component';
import { GridHeader } from '../rankings/models/gridHeader';
import { APP_OS_OPTIONS, CTV_OS_OPTIONS, OsOption } from './FILTERS_CONFIG';

export interface ReportConfig {
  key: string;
  title: string;
  heading: string;
  subHeading: string;
  reportId: string;
  gridHeaders: GridHeader[];
  permissions: string[];
  defaultSort?: string;
  pageTitle?: string;
  pageMeta?: string;
  sortable?: boolean;
  showTitle?: boolean;
  notHideDataIfNA?: boolean;
  osFilterOptions?: OsOption[];
  selectedGroup?: string;
  rowLimit?: number;
  fadeStart?: number;
  ctaButton?: string;
  cta?: CtaConfig;
}

export interface CtaConfig {
  anonHeading?: string;
}

export const DEFAULT_CTA: CtaConfig = {
  anonHeading: 'Unlock Scores:'
};

export const REPORT_CONFIG: ReportConfig[] = [
  {
    key: 'ipv4-addresses',
    heading: 'IPv4 Addresses',
    subHeading:
      'IPv4 addresses associated with malicious infrastructure or high-risk activity originating at end-points.',
    title: 'IPv4 Addresses',
    pageTitle: 'AdFraud IOC-DB: IPv4 Address Ad Fraud Blocklist | Pixalate',
    pageMeta:
      'Explore Pixalate’s Ad Fraud Watch List of IPv4 addresses most frequently linked to invalid traffic and ad fraud. Stay ahead of threats with updated data to protect your programmatic campaigns.',
    reportId: 'highRiskIpv4',
    sortable: false,
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    ctaButton: 'Block High-Risk IPv4s',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Identifier',
        key: 'ip',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Primary Ad Fraud Type Observed',
        key: 'fraudType',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'ISP',
        key: 'organization',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'ipv6-addresses',
    heading: 'IPv6 Addresses',
    subHeading:
      'IPv6 addresses associated with malicious infrastructure or high-risk  activity originating at end-points.',
    title: 'IPv6 Addresses',
    pageTitle: 'AdFraud IOC-DB: IPv6 Address Ad Fraud Blocklist | Pixalate',
    pageMeta:
      'Access Pixalate’s High Risk IPv6 Registry to detect addresses tied to fraudulent behavior and IVT. Keep your ad delivery safe across all environments with timely updates.',
    sortable: false,
    reportId: 'highRiskIpv6',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    ctaButton: 'Block High-Risk IPv6s',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Identifier',
        key: 'ip',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Primary Ad Fraud Type Observed',
        key: 'fraudType',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'ISP',
        key: 'organization',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'data-center-ips',
    heading: 'Data Center IPs',
    subHeading:
      'Data center IPs that frequently source non-human traffic, including botnets and crawlers, or are used in malicious campaigns.',
    title: 'Data Center IPs',
    pageTitle: 'AdFraud IOC-DB: Data Center IP Ad Fraud Blocklist | Pixalate',
    pageMeta:
      'Uncover data center IPs frequently used in automated ad fraud. Pixalate’s Ad Fraud Watch List helps block non-human traffic and protect advertiser spend.',
    sortable: false,
    reportId: 'highRiskDCIp',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    ctaButton: 'Block High-Risk Data Centers',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Identifier',
        key: 'ip',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Primary Ad Fraud Type Observed',
        key: 'fraudType',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'ISP',
        key: 'organization',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'ctv-device-ids',
    heading: 'CTV Device IDs',
    subHeading:
      'CTV device IDs linked to high IVT volumes or nefarious/malicious activity.',
    title: 'CTV Device IDs',
    pageTitle: 'AdFraud IOC-DB: CTV Device ID Ad Fraud Blocklist | Pixalate',
    pageMeta:
      'Discover CTV device IDs linked to invalid traffic in connected TV advertising. Use Pixalate’s Ad Fraud Watch List to maintain transparency and improve campaign quality.',
    sortable: false,
    reportId: 'highRiskOttDevice',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    ctaButton: 'Block High-Risk CTV Device IDs',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Device ID',
        key: 'deviceId',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Primary Ad Fraud Type Observed',
        key: 'fraudType',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'OS',
        key: 'os',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: OsNameComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'mobile-device-ids',
    heading: 'Mobile Device IDs',
    subHeading:
      'Mobile device IDs linked to high IVT volumes or nefarious activity.',
    title: 'Mobile Device IDs',
    pageTitle: 'AdFraud IOC-DB: Mobile Device ID Ad Fraud Blocklist | Pixalate',
    pageMeta:
      'Protect your mobile campaigns with Pixalate’s Ad Fraud Watch List of flagged device IDs. Identify suspicious mobile activity and reduce ad fraud risk at scale.',
    sortable: false,
    reportId: 'highRiskMobileDevice',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    ctaButton: 'Block High-Risk Mobile Device IDs',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Device ID',
        key: 'deviceId',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Primary Ad Fraud Type Observed',
        key: 'fraudType',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'OS',
        key: 'os',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: OsNameComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'fraudulent-ctv-bundles',
    heading: 'Fraudulent CTV Bundle IDs',
    subHeading:
      'Illegitimate or spoofed CTV bundle IDs used in fraud or impersonation.',
    title: 'Fraudulent CTV Bundle IDs',
    pageTitle:
      'AdFraud IOC-DB: Fraudulent CTV Bundle ID Ad Fraud Blocklist | Pixalate',
    pageMeta:
      'Find CTV bundle IDs associated with spoofing or misrepresentation. Pixalate’s Ad Fraud Watch List helps advertisers block fake CTV apps and recover wasted spend.',
    sortable: false,
    reportId: 'highRiskMalformedCtvBundleId',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    ctaButton: 'Block High-Risk CTV Bundle IDs',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Identifier',
        key: 'bundleId',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Platform Name',
        key: 'platformName',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'OS',
        key: 'os',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: OsNameComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'mobile-delisted-apps',
    heading: 'Mobile Delisted Apps',
    subHeading:
      'Mobile apps delisted from stores but still active, generating ad impressions or indicating supply chain risks.',
    title: 'Mobile Delisted Apps',
    pageTitle: 'AdFraud IOC-DB: Mobile Delisted Apps | Pixalate',
    pageMeta:
      'Discover mobile apps that have been delisted from app stores but remain active, generating ad impressions and posing potential risks to the programmatic supply chain.',
    sortable: false,
    reportId: 'highRiskDefasedMobileApps',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    osFilterOptions: APP_OS_OPTIONS,
    selectedGroup: 'app',
    ctaButton: 'Block Delisted Mobile Apps',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Id',
        key: 'appId',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppIdOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Name',
        key: 'appTitle',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppNameOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Developer',
        key: 'publisherName',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'OS',
        key: 'os',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: OsNameComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'ctv-delisted-apps',
    heading: 'CTV Delisted Apps',
    subHeading:
      'CTV apps delisted from stores but still active, generating ad impressions or indicating supply chain risks.',
    title: 'CTV Delisted Apps',
    pageTitle: 'AdFraud IOC-DB: CTV Delisted Apps | Pixalate',
    pageMeta:
      'Explore CTV apps that have been delisted from app stores yet remain active, continuing to generate ad traffic and introducing risks to the programmatic supply chain.',
    sortable: false,
    reportId: 'highRiskDefasedCtvApps',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    osFilterOptions: CTV_OS_OPTIONS,
    selectedGroup: 'ctv',
    ctaButton: 'Block Delisted CTV Apps',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Id',
        key: 'appId',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppIdOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Name',
        key: 'appTitle',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppNameOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Developer',
        key: 'publisherName',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'OS',
        key: 'os',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: OsNameComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'mfa-ctv-apps',
    heading: 'Highest Risk Made-For-Advertising (MFA) CTV Apps',
    subHeading:
      'CTV apps built to maximize ad revenue with low-value content, posing ad fraud and brand safety risks.',
    title: 'Highest Risk Made-For-Advertising (MFA) CTV Apps',
    pageTitle: 'AdFraud IOC-DB: MFA CTV Apps | Pixalate',
    pageMeta: '',
    sortable: false,
    reportId: 'highRiskMfaCtvApps',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    osFilterOptions: CTV_OS_OPTIONS,
    selectedGroup: 'ctv',
    ctaButton: 'Block MFA CTV Apps',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Id',
        key: 'appId',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppIdOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Name',
        key: 'appTitle',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppNameOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Developer',
        key: 'publisherName',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'OS',
        key: 'os',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: OsNameComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'mfa-mobile-apps',
    heading: 'Highest Risk Made-For-Advertising (MFA) Mobile Apps',
    subHeading:
      'Mobile apps built to maximize ad revenue with low-value content, posing ad fraud and brand safety risks.',
    title: 'Highest Risk Made-For-Advertising (MFA) Mobile Apps',
    pageTitle: 'AdFraud IOC-DB: MFA Mobile Apps | Pixalate',
    pageMeta: '',
    sortable: false,
    reportId: 'highRiskMfaMobileApps',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 3,
    osFilterOptions: APP_OS_OPTIONS,
    selectedGroup: 'app',
    ctaButton: 'Block MFA Mobile Apps',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Id',
        key: 'appId',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppIdOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'App Name',
        key: 'appTitle',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: AppNameOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Developer',
        key: 'publisherName',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'OS',
        key: 'os',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: OsNameComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        lockIfAnonymous: true,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  },
  {
    key: 'mfa-domains',
    heading: 'Highest Risk Made-For-Advertising (MFA) Domains',
    subHeading:
      'Websites built to maximize ad revenue with low-value content, posing ad fraud and brand safety risks.',
    title: 'Highest Risk Made-For-Advertising (MFA) Domains',
    pageTitle: 'AdFraud IOC-DB: MFA Domains | Pixalate',
    pageMeta: '',
    sortable: false,
    reportId: 'highRiskMfaDomains',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    rowLimit: 10,
    fadeStart: 1,
    ctaButton: 'Block MFA Websites',
    cta: DEFAULT_CTA,
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Risk',
        key: 'risk',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: RatingSignalComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Domain',
        key: 'domain',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'Last Seen',
        key: 'lastSeen',
        sort: 'sort-asc',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        tooltipText: {
          app: null,
          ctv: null,
          domain: null
        },
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      }
    ]
  }
];
